import { useAppContext } from "../hooks/useAppContext";
import { getTranslation } from "../locales/getTranslation";
import Ani from "./SVGIcons/Ani";

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

export const ClearChatButton = ({ disabled, onClick }: Props) => {
  const { locale } = useAppContext();

  return (
    <div
      className={`group relative flex h-[36px] cursor-pointer items-center justify-center gap-2 rounded-[300px] bg-grayscale-solid-g1 p-[6px] hover:bg-blue-opacity-level2 md:py-1 md:pl-1 md:pr-3`}
      onClick={() => {
        if (!disabled) {
          onClick();
        }
      }}
    >
      <Ani className="h-4 w-4 fill-grayscale-solid-g10" />

      <span className="text-center text-[12px] font-medium leading-snug text-grayscale-solid-g10 sm:block">
        {getTranslation(locale, "New chat")}
      </span>
    </div>
  );
};
